/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyDto } from './companyDto';


export interface ManualTransactionDto { 
    status?: ManualTransactionDto.StatusEnum;
    errorMessage?: string;
    points?: number;
    finishedAt?: string;
    created?: string;
    type?: ManualTransactionDto.TypeEnum;
    adminOverride?: boolean;
    company?: CompanyDto;
    explanation?: string;
}
export namespace ManualTransactionDto {
    export type StatusEnum = 'INITIALIZED' | 'SUCCESS' | 'VALIDATION_PENDING' | 'ERROR' | 'DECLINED' | 'REPORTED';
    export const StatusEnum = {
        Initialized: 'INITIALIZED' as StatusEnum,
        Success: 'SUCCESS' as StatusEnum,
        ValidationPending: 'VALIDATION_PENDING' as StatusEnum,
        Error: 'ERROR' as StatusEnum,
        Declined: 'DECLINED' as StatusEnum,
        Reported: 'REPORTED' as StatusEnum
    };
    export type TypeEnum = 'INVOICE_SCAN' | 'COUPON_BOUGHT' | 'MANUAL_TRANSACTION';
    export const TypeEnum = {
        InvoiceScan: 'INVOICE_SCAN' as TypeEnum,
        CouponBought: 'COUPON_BOUGHT' as TypeEnum,
        ManualTransaction: 'MANUAL_TRANSACTION' as TypeEnum
    };
}


